import { IFeatureProperties } from '../../../../../../common/types/map';
import { beautify } from '../../../../../../common/utils/number';
import { pluralize } from '../../../../../../common/utils/pluralize';
import { getMinPrice } from '../../../../../../common/utils/ymapsModules/BalloonManager/getPinViewModel';

const OFFER_FORMS: [string, string, string] = ['объявление', 'объявления', 'объявлений'];

/**
 * Шапка шторки мультипина: «6 объявлений от 5 600 ₽», без цен - «6 объявлений».
 * Число полное (не «9+», как на пине).
 */
export function getMultipinSheetTitle({ offers }: IFeatureProperties): string {
  const title = `${offers.length} ${pluralize(offers.length, OFFER_FORMS)}`;
  const minPrice = getMinPrice(offers);

  return minPrice === null ? title : `${title} от ${beautify(minPrice)} ₽`;
}
